export const selectSalonServicesCategories = ($) => $?.salon?.services?.categories;
export const selectSalonIsServicesCategoriesFetched = ($) => Array.isArray($?.salon?.services?.categories);
export const selectSalonStylistListRemovedAccess = ($) => $?.salon?.stylistList?.removedAccess ?? null;
export const selectSalonStylistListEmailsWithLogin = ($) => $?.salon?.stylistList?.emailsWithLogin ?? null;
